import { Link } from "react-router-dom";

import AuthLayout from "../layout/AuthLayout";
import JobSeekerRegistrationForm from "./JobSeekerRegistrationForm";

function RegisterScreen() {
	return (
		<AuthLayout>
			<div className="py-12 flex flex-col h-full justify-center">
				<Link to="/" className="block md:hidden">
					<img
						src="/images/logo.png"
						alt="DProz Logo"
						className="p-2 mb-8 mx-auto"
						style={{
							width: "180px",
						}}
					/>
				</Link>
				<div className="mb-6">
					<h3 className="font-bold font-plus-jakarta text-xl">Your dream job is just a click away!</h3>
					<p className="text-[#5C5C5C] text-base font-inter">Create your free account — it takes less than a minute.</p>
				</div>
				<JobSeekerRegistrationForm />
			</div>
		</AuthLayout>
	);
}

export default RegisterScreen;
